<footer class="wrap p-4 shadow border-top min-vh-100">
  <div class="container">
    <div class="row">
      <div class="col-12 fs-3 fw-bold text-start mt-3 mb-3">
        {{ store?.store_name }}
      </div>
      <div class="col-12 d-flex flex-column flex-xl-row">
        <div class="col-12 col-xl-6 pe-xl-4">
          <div
            class="map border bg-secondary rounded user-select-none position-relative"
            *ngIf="store && (store?.latitude || store?.address)"
          >
            <a
              [href]="getGoogleMapsLink()"
              target="_blank"
              rel="noopener noreferrer"
              class="d-block w-100 h-100"
            >
              <img
                [src]="getStaticMapUrl()"
                alt="Store Location Map"
                class="w-100 h-100"
                style="object-fit: cover; border-radius: inherit;"
                (error)="onImageError($event)"
                loading="lazy"
                #mapImage
              />
              <div
                *ngIf="mapError"
                class="d-flex align-items-center justify-content-center w-100 h-100 position-absolute top-0 start-0"
                style="background-color: #e9ecef; border-radius: inherit;"
              >
                <div class="text-center p-3">
                  <i class="bi bi-geo-alt-fill fs-1 text-secondary"></i>
                  <p class="text-secondary mt-2 mb-0">Map unavailable</p>
                  <small class="text-muted">Click to open in Google Maps</small>
                </div>
              </div>
            </a>
          </div>
          <div
            class="col-12 fs-3 fw-bold text-start pt-2 user-select-none d-inline-flex"
            *ngIf="
              store?.address || store?.zipcode || store?.state || store?.city
            "
          >
            <a
              class="text-dark fs-6 flex-fill"
              placement="bottom"
              ngbTooltip="Find store"
              [href]="
                'http://maps.google.com/?q=' +
                store?.address +
                ',' +
                store?.city +
                ',' +
                store?.state +
                ',' +
                store?.zipcode
              "
              target="_blank"
            >
              {{ store?.address + "," }}
              <ng-container *ngIf="store?.optional"
                >{{ store?.optional + "," }}
              </ng-container>
              {{ store?.city + "," | titlecase }}
              {{ store?.state + "," | titlecase }}
              {{ store?.zipcode }}</a
            >
          </div>
        </div>
        <div class="col-12 col-xl-6" id="storeHourAnckor">
          <div
            class="col-12 fs-4 fw-bold text-start user-select-none mt-3 mb-2 mt-xl-0"
          >
            Hours
          </div>
          <ng-container *ngFor="let hour of businessHours">
            <div class="d-flex flex-column mt-1 fw-500">
              <div class="d-inline-flex">
                <div class="fs-6 w-day fw-500 text-start user-select-none">
                  {{ hour.day }}
                </div>
                <ng-container *ngIf="hour.scope?.length; else nonScopeTemplate">
                  <div class="d-flex flex-column flex-fill align-items-start">
                    <ng-container *ngFor="let scope of hour.scope">
                      {{ scope.open_hour }}-{{ scope.close_hour }}
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #nonScopeTemplate>Store Closed</ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- Full-width UP info section -->
  <div class="footer-info-bg position-relative">
    <img
      src="assets/icons/up-icon.png"
      alt="UP Icon"
      class="position-absolute end-0 top-0 mt-3 me-3"
      style="height: 2em; width: auto"
    />
    <div class="container">
      <div class="row mt-5">
        <div class="col-12 col-xl-3 d-flex flex-column">
          <div
            class="col-12 fs-5 fw-bold text-start mt-3 mb-3 d-flex align-items-center position-relative"
          >
            <span class="d-inline-flex align-items-center">
              Get to know UP
            </span>
          </div>
          <a
            href="https://www.uprocessing.com/about"
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >About UP
          </a>
          <a
            href="https://www.uprocessing.com/solutions"
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Solutions
          </a>
          <a
            href="https://www.uprocessing.com/careers"
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Career
          </a>
        </div>
        <div class="col-12 col-xl-3 d-flex flex-column">
          <div class="col-12 fs-5 fw-bold text-start mt-3 mb-3">
            Social Links
          </div>
          <div class="col-12 d-inline-flex">
            <a
              *ngFor="let item of store?.social_media; let i = index"
              href="{{ item.link }}"
              [ngClass]="
                i === 0
                  ? 'fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2 pe-2'
                  : 'fs-6 fw-bold mt-1 mb-1 text-dark text-start p-2'
              "
              ><i
                *ngIf="item.key.includes('linkedin')"
                class="bi bi-linkedin"
              ></i>
              <i
                *ngIf="item.key.includes('facebook')"
                class="bi bi-facebook"
              ></i>
              <i
                *ngIf="item.key.includes('instagram')"
                class="bi bi bi-instagram"
              ></i>
              <i
                *ngIf="item.key.includes('twitter')"
                class="bi bi bi-twitter"
              ></i>
              <i
                *ngIf="item.key.includes('wechat')"
                class="bi bi bi-wechat"
              ></i>
            </a>
          </div>
        </div>
        <div class="col-12 col-xl-3 d-flex flex-column">
          <div class="col-12 fs-5 fw-bold text-start mt-3 mb-3">Help</div>
          <a
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Add your restaruant
          </a>

          <a
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Support
          </a>
        </div>
        <div class="col-12 col-xl-3 d-flex flex-column">
          <div class="col-12 fs-5 fw-bold text-start mt-3 mb-3">Quick Find</div>
          <a
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Restaurants near me
          </a>
          <a
            class="col-12 fs-6 fw-bold mt-1 mb-1 text-dark text-start pt-2 pb-2"
            >Pick up near me
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- Full-width copyright/terms section -->
  <div class="footer-bottom-bg">
    <div class="container">
      <div class="row user-select-none">
        <div class="offset-4 col-2">
          <a routerLink="/terms" class="text-dark fs-6 fw-500 user-select-none"
            >Terms</a
          >
        </div>
        <div class="col-2">
          <a
            routerLink="/privacy"
            class="text-dark fs-6 fw-500 user-select-none"
            >Privacy</a
          >
        </div>
        <div class="col-4"></div>
        <div class="col-12">
          Universal Processing LLC is a registered ISO of MVB Bank Inc,
          Fairmont, WV 26554, Wells Fargo Bank, N.A., Concord, CA, and The Fifth
          Third Bank, N.A., Cincinnati, OH.
        </div>
      </div>
      <div class="row">
        <div class="col-12 user-select-none">
          uServe © 2003-2022 All Rights Reserved | Powered by Universal
          Processing LLC
        </div>
      </div>
    </div>
  </div>
</footer>
